// extracted by mini-css-extract-plugin
export default {"infoWrapper":"UserNotAuthorized_infoWrapper__jmnfY","content":"UserNotAuthorized_content__9OC-j","text":"UserNotAuthorized_text__e4CeV"};